import React, { useState, useEffect } from "react";
import apiService from "../../services/api";

const ApiTestPage = () => {
  const [status, setStatus] = useState("Connecting...");
  const [tokens, setTokens] = useState([]);
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    testConnection();
  }, []);

  const testConnection = async () => {
    try {
      // Test API connection
      const healthResponse = await apiService.checkHealth();
      setStatus("Connected");

      // Try to get user info
      const userFromStorage = localStorage.getItem("user");
      if (userFromStorage) {
        setUser(JSON.parse(userFromStorage));
      }

      // Try to load tokens if authenticated
      const token = localStorage.getItem("authToken");
      if (token) {
        try {
          const tokensResponse = await apiService.tokens.getTokens();
          setTokens(tokensResponse.data.data || []);
        } catch (err) {
          setError(
            "Failed to load tokens: " +
              (err.response?.data?.error || err.message),
          );
        }
      } else {
        setError("No auth token found in localStorage");
      }
    } catch (err) {
      setStatus("Connection failed");
      setError("API connection failed: " + err.message);
    }
  };

  const handleLogin = async () => {
    try {
      const response = await apiService.auth.login({
        username: "admin",
        password: "password123",
      });

      const { data } = response.data;
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      setUser(data.user);
      setError("");

      // Reload tokens after login
      testConnection();
    } catch (err) {
      setError("Login failed: " + (err.response?.data?.error || err.message));

      // For testing purposes, set fake auth if login fails
      const fakeUser = {
        id: 1,
        username: "admin",
        email: "admin@example.com",
        role: "admin",
        status: "active",
      };
      const fakeToken = "fake_jwt_token_for_testing";

      localStorage.setItem("authToken", fakeToken);
      localStorage.setItem("user", JSON.stringify(fakeUser));
      setUser(fakeUser);
      setError("Using fake auth for testing");

      // Force page reload to trigger authentication state change
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const handleBypassAuth = () => {
    // Set fake auth for testing frontend components
    const fakeUser = {
      id: 1,
      username: "admin",
      email: "admin@example.com",
      role: "admin",
      status: "active",
    };
    const fakeToken = "fake_jwt_token_for_testing";

    localStorage.setItem("authToken", fakeToken);
    localStorage.setItem("user", JSON.stringify(fakeUser));
    setUser(fakeUser);
    setError("Using fake auth for frontend testing");

    // Force page reload to trigger authentication state change
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const navigateToPage = (path) => {
    window.location.href = path;
  };

  const testDirectApiCall = async () => {
    try {
      // Test direct API call to users endpoint
      const response = await fetch(
        "http://localhost:9080/api/v1/users?page=1&page_size=10",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer fake_jwt_token_for_testing`,
          },
        },
      );

      const data = await response.json();
      console.log("Direct API response:", data);
      setError("Direct API call result: " + JSON.stringify(data, null, 2));
    } catch (err) {
      setError("Direct API call failed: " + err.message);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "monospace" }}>
      <h2>API Connection Test</h2>

      <div style={{ marginBottom: "20px" }}>
        <strong>Status:</strong> {status}
      </div>

      {error && (
        <div style={{ color: "red", marginBottom: "20px" }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      <div style={{ marginBottom: "20px" }}>
        <strong>Current User:</strong>{" "}
        {user ? JSON.stringify(user, null, 2) : "Not logged in"}
      </div>

      {!user && (
        <div>
          <button
            onClick={handleLogin}
            style={{ marginBottom: "10px", marginRight: "10px" }}
          >
            Login as Admin
          </button>
          <button onClick={handleBypassAuth} style={{ marginBottom: "10px" }}>
            Bypass Auth (Frontend Testing)
          </button>
        </div>
      )}

      {user && (
        <div style={{ marginBottom: "20px" }}>
          <button
            onClick={() => navigateToPage("/users")}
            style={{ margin: "5px" }}
          >
            Go to Users Page
          </button>
          <button
            onClick={() => navigateToPage("/tokens")}
            style={{ margin: "5px" }}
          >
            Go to Tokens Page
          </button>
          <button
            onClick={() => navigateToPage("/dashboard")}
            style={{ margin: "5px" }}
          >
            Go to Dashboard
          </button>
        </div>
      )}

      <div>
        <strong>Tokens ({tokens.length}):</strong>
        <pre
          style={{ background: "#f0f0f0", padding: "10px", overflow: "auto" }}
        >
          {JSON.stringify(tokens, null, 2)}
        </pre>
      </div>

      <button onClick={testConnection}>Refresh</button>
      <button onClick={testDirectApiCall} style={{ marginLeft: "10px" }}>
        Test Direct API Call
      </button>
    </div>
  );
};

export default ApiTestPage;
